import { render, staticRenderFns } from "./EmployeeJobExitDetail.vue?vue&type=template&id=24d302ed&"
import script from "./EmployeeJobExitDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeJobExitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports